import React, { useState, useEffect } from 'react'
import { Box, Hidden } from '@material-ui/core'
import { useStyles } from './SchoolNews_style'
import SectionSubTitle from 'components/SectionSubTitle/SectionSubTitle'
import TrendMainArticleCard from 'cards/NewsCard/TrendMainArticleCard/TrendMainArticleCard'
import ArticleListMinimalCard from 'cards/NewsCard/ArticleListMinimalCard/ArticleListMinimalCard'
import ArticlesList from 'components/ArticlesList/ArticlesList'
import SchoolAPI from 'api/SchoolAPI'
import Button from 'shared/components/Button/Button.jsx'
import { FormattedMessage } from 'react-intl'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import CTAAlert from 'components/CTAAlert/CTAAlert'
import { SCHOOL_INDEX_SCHOOL_NEWS } from 'assets/AlertsHelper'
import isEmpty from 'lodash.isempty'

const SchoolNews = (props) => {
    const { user } = props
    const classes = useStyles()
    const [mainArticle, setMainArticle] = useState(null)
    const [minimalArticles, setMinimalArticles] = useState([])
    const [listArticles, setListArticles] = useState([])
    const [mobileArticles, setMobileArticles] = useState([])

    useEffect(() => {
        SchoolAPI.GetSchoolNews().then((response) => {
            setMainArticle(response.data.main_article)
            setMinimalArticles(response.data.minimal_articles)
            setListArticles(response.data.list_articles)
            setMobileArticles(response.data.mobile_articles)
        })
    }, [])

    if (isEmpty(mainArticle)) return null

    return (
        <Box className={''}>
            <SectionSubTitle titleId='school_index.school_news.title' descriptionId='school_index.school_news.description'/>
            <Hidden smDown>
                <Box className={classes.trendArticesSection}>
                    <TrendMainArticleCard article={mainArticle} />
                    {minimalArticles &&
                        <Box className={classes.articleMinimalCardsContainer}>
                            {minimalArticles.map((article, index) => <ArticleListMinimalCard article={article} key={index} />)}
                        </Box>
                    }
                </Box>
                {listArticles &&
                    <Box className={classes.recentArticlesSection}>
                        <ArticlesList articles={listArticles} />
                    </Box>
                }
            </Hidden>
            <Hidden mdUp>
                {mobileArticles &&
                    <Box className={classes.recentArticlesSection}>
                        <ArticlesList articles={listArticles} />
                    </Box>
                }
            </Hidden>
            <Box className={classes.showMoreButtonBox}>
                <RouteMapLink articleCategory='education'>
                    <Button size='small' className={classes.showMoreButton}>
                        <FormattedMessage id='item_index.show_more_button' />
                    </Button>
                </RouteMapLink>
            </Box>
            <Box className={classes.ctaBox}>
                <CTAAlert
                    type='student_job'
                    user={user}
                    componentType='banner'
                    origin={SCHOOL_INDEX_SCHOOL_NEWS}
                />
            </Box>
        </Box>
    )
}

export default SchoolNews
